"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAccess = exports.UserDocumentTitle = exports.UserPointType = exports.Products = exports.AppName = exports.Source = void 0;
var Source;
(function (Source) {
    Source["TrackApp"] = "track-app";
    Source["TrackWeb"] = "track-web";
    Source["FleetApp"] = "fleet-app";
    Source["FleetWeb"] = "fleet-web";
    Source["Website"] = "website";
    Source["TimekeeperApp"] = "timekeeper-app";
    Source["LogisticsApp"] = "logistics-app";
})(Source = exports.Source || (exports.Source = {}));
var AppName;
(function (AppName) {
    AppName["FleetManager"] = "fleetmanager";
    AppName["Timekeeper"] = "timekeeper";
    AppName["TenderdTrack"] = "tenderdtrack";
    AppName["Logistics"] = "logistics";
})(AppName = exports.AppName || (exports.AppName = {}));
var Products;
(function (Products) {
    Products["Track"] = "track";
    Products["Fleet"] = "fleet";
    Products["Website"] = "website";
    Products["Saas"] = "sass";
    Products["Marketplace"] = "marketplace";
})(Products = exports.Products || (exports.Products = {}));
var UserPointType;
(function (UserPointType) {
    UserPointType["Login"] = "login";
    UserPointType["ViewProject"] = "view-project";
    UserPointType["InquirySubmission"] = "inquiry-submission";
    UserPointType["RequestCreation"] = "request-creation";
    UserPointType["TimekeeperCreation"] = "timekeeper-creation";
    UserPointType["MarketplaceCreation"] = "marketplace-creation";
    UserPointType["LogisticsCreation"] = "logistics-creation";
    UserPointType["EditPrices"] = "edit-prices";
    UserPointType["SubmitBid"] = "submit-bid";
    UserPointType["AcceptTrip"] = "accept-trip";
})(UserPointType = exports.UserPointType || (exports.UserPointType = {}));
var UserDocumentTitle;
(function (UserDocumentTitle) {
    UserDocumentTitle["TimesheetTemplate"] = "Timesheet Template";
    UserDocumentTitle["TimesheetHeaderTemplate"] = "Timesheet Header Template";
    UserDocumentTitle["TimesheetFooterTemplate"] = "Timesheet Footer Template";
})(UserDocumentTitle = exports.UserDocumentTitle || (exports.UserDocumentTitle = {}));
var UserAccess;
(function (UserAccess) {
    UserAccess["Admin"] = "admin";
    UserAccess["CreateProject"] = "create-project";
    UserAccess["CreateYard"] = "create-yard";
    UserAccess["EditProject"] = "edit-project";
    UserAccess["EditYard"] = "edit-yard";
    UserAccess["ViewProject"] = "view-project";
    UserAccess["ViewYard"] = "view-yard";
    UserAccess["Any"] = "*"; // if there is any kind of access.
})(UserAccess = exports.UserAccess || (exports.UserAccess = {}));
//# sourceMappingURL=user.js.map